import { Avatar, Button, Col, Row, Tag } from 'antd';
import Picker, { SkinTones } from 'emoji-picker-react';
import dayjs from 'dayjs';
import { useState } from 'react';
import { AiOutlineClose, AiOutlineUser } from 'react-icons/ai';
import { BsBuilding, BsEmojiWinkFill } from 'react-icons/bs';

import { timeAgo } from '../../utils/date';
import { titlize } from '../../utils/strings';
import { CommentInput } from './comment-input';
import './styles.css';

export function CommentItem({
	onFocus,
	onChange,
	commenter,
	editable,
	comment,
	emojis,
	attachments,
	commentDate,
	onDelete,
	onEdit,
	onSetEmoji,
	pRef
}: any) {
	let [editMode, setEditMode] = useState(false);
	const [loading, setLoading] = useState(false);
	const [chosenEmoji, setChosenEmoji] = useState<any>(null);
	const [isEmojiOpen, setIsEmojiOpen] = useState(false);
	const [visibleFile, setVisibleFile] = useState(null);

	const onEmojiClick = emojiObject => {
		setIsEmojiOpen(false);
		setChosenEmoji(emojiObject);
		onSetEmoji(emojiObject);
	};
	const [pdfViewerState, setPdfViewerState] = useState({
		visible: false,
		url: '',
		title: '',
		downloadable: false
	});
	function get_url_extension(url) {
		return url?.split(/[#?]/)[0]?.split('.')?.pop()?.trim();
	}
	return (
		<>
			<Row className="comment-container">
				<Col xs={3} sm={2}>
					<Avatar
						size={32}
						src={commenter.avatar || null}
						shape="circle"
						style={{
							backgroundColor: commenter.avatarBgColor || '#4ADCAA'
						}}
					>
						<span style={{ mixBlendMode: 'difference' }}>{`${titlize(commenter.firstName[0])}${titlize(
							commenter.lastName[0]
						)}`}</span>
					</Avatar>
				</Col>

				<Col xs={21} sm={22}>
					<div className="comment-header">
						<div className="comment-header--commenter">{`${titlize(commenter.firstName)} ${titlize(
							commenter.lastName
						)}`}</div>
						<div className="comment-header--date">
							{dayjs(commentDate).format('ddd, MMM D, YYYY h:mm A')}
						</div>
					</div>
					<div className="comment-content">
						{editable && editMode ? (
							<CommentInput
								disabled={loading}
								onSave={(val, attachment, callback) => {
									setLoading(true);
									onEdit(val, err => {
										setLoading(false);
										callback(err);
										setEditMode(!!err);
									});
								}}
								onCancel={() => setEditMode(false)}
								loading={loading}
								richEditor
								focused
								value={comment}
								// pRef={pRef}
							/>
						) : (
							<p
								// ref={pRef}
								style={{ color: 'rgb(23, 43, 77)', width: 'fit-content' }}
								dangerouslySetInnerHTML={{ __html: comment }}
							></p>
						)}
					</div>
					<div className="comment-controls">
						{emojis?.map(cEmoji => (
							<Tag
								color={cEmoji?.isMe ? 'geekblue' : 'default'}
								className="me-2 d-inline-flex align-items-center"
							>
								<span>{cEmoji?.emoji}</span>
								<span className="border-left ps-2 ms-2 d-inline-flex align-items-center">
									{(() => {
										if (cEmoji?.role === 'company_owner') {
											return <BsBuilding className="me-1" />;
										} else {
											return <AiOutlineUser className="me-1" />;
										}
									})()}
									{cEmoji?.firstName}
								</span>
							</Tag>
						))}
					</div>
					<div className="comment-controls">
						{(() => {
							if (isEmojiOpen) {
								return (
									<>
										<div className="d-flex justify-content-center align-items-start flex-column">
											<Button
												onClick={() => {
													setIsEmojiOpen(false);
												}}
												type="dashed"
												className="border-0"
												shape="circle"
												icon={
													<span className="w-100 d-flex align-items-start">
														<AiOutlineClose className="text-danger" />
													</span>
												}
											/>
											<Picker onEmojiClick={onEmojiClick} autoFocusSearch={false} />
										</div>
									</>
								);
							} else {
								return (
									<>
										<div className="" style={{ maxWidth: '25px' }}>
											<Button
												onClick={() => {
													setIsEmojiOpen(!isEmojiOpen);
												}}
												type="dashed"
												className="border-0"
												shape="circle"
												icon={
													<span className="w-100 d-flex align-items-start">
														{chosenEmoji?.emoji || <BsEmojiWinkFill />}
													</span>
												}
											/>
										</div>
									</>
								);
							}
						})()}
						{editable && (
							<>
								<div className="comment-controls__control">
									<button
										className="comment-controls__control btn"
										type="button"
										tabIndex={0}
										onClick={() => setEditMode(true)}
									>
										<span>Edit</span>
									</button>
								</div>
								<div className="comment-controls__control">
									<button
										className="comment-controls__control btn"
										type="button"
										tabIndex={0}
										onClick={onDelete}
									>
										<span>Delete</span>
									</button>
								</div>
							</>
						)}
						{/* {Array.isArray(attachments) && attachments?.length !== 0 && (
							<div className="d-flex flex-column w-100" style={{ zIndex: 1 }}>
								{attachments?.map(attachment => (
									<a
										href={attachment}
										key={attachment}
										onClick={async e => {
											e.preventDefault();
											await setVisibleFile(null);
											await setVisibleFile(attachment);
										}}
									>
										View {get_url_extension(attachment)?.toUpperCase()} File
									</a>
								))}
							</div>
						)} */}
					</div>
				</Col>
			</Row>
			{/* {visibleFile && (
				<Modal
					title="File viewer"
					centered
					visible={visibleFile !== null}
					onOk={() => setVisibleFile(null)}
					onCancel={() => setVisibleFile(null)}
					width={1000}
				>
					<div style={{ height: '100%', width: '100%' }}>
						<FileViewer
							fileType={get_url_extension(visibleFile)}
							filePath={visibleFile}
							errorComponent={CustomErrorComponent}

							// onError={this.onError}
						/>
					</div>
				</Modal>
			)} */}
		</>
	);
}
